import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import useScreen from 'hooks/useScreen';
import FAQAccordionUI from 'components/consumer/user-orders-build-updates/FAQAccordion/FAQAccordionUI';
import Link from 'components/consumer/Link';
const FAQs = t0 => {
  const $ = _c(7);
  const {
    steps
  } = t0;
  const [activeIndex, setActiveIndex] = useState(-1);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="text-sm">Have another question? Please visit our{" "}<Link to="/contact-us/" className="text-brand !no-underline hover:!no-underline">Contact Us</Link>.</div>;
    t2 = <div className="mx-0 my-6 [border-top:1px_solid_#e5e5e5]" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== activeIndex || $[3] !== steps) {
    t3 = steps.length > 0 && steps.map((step, idx) => <FAQAccordionUI key={step.question} title={step.question} content={step.answer} isActive={idx === activeIndex} toggleAccordion={() => {
      setActiveIndex(idx === activeIndex ? -1 : idx);
    }} />);
    $[2] = activeIndex;
    $[3] = steps;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
FAQs.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.shape({
    question: PropTypes.string,
    answer: PropTypes.string
  }))
};
const FAQCommonQuestionsUI = t0 => {
  const $ = _c(4);
  const {
    steps
  } = t0;
  const {
    isMobile
  } = useScreen();
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] !== isMobile || $[1] !== isOpen || $[2] !== steps) {
    t1 = <div className="rounded-lg md:px-10 md:py-12 md:bg-gray-light9">{isMobile ? <FAQAccordionUI title="Common questions" content={<FAQs steps={steps} />} isActive={isOpen} hasInnerAccordion={true} toggleAccordion={() => {
        setIsOpen(!isOpen);
      }} /> : <><div className="text-lg font-bold text-gray">Common questions</div><FAQs steps={steps} /></>}</div>;
    $[0] = isMobile;
    $[1] = isOpen;
    $[2] = steps;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
FAQCommonQuestionsUI.propTypes = FAQs.propTypes;
export default FAQCommonQuestionsUI;